export default {

    FRONTEND_VERSION_HEADER : 'app-dealer-fev',
    VERSION_CHANGED_RELOAD_REDIRECT_TO_PATH_KEY : 'dealer_version_changed_reload_path',
    FRONTEND_VERSION_STORAGE_KEY : 'dealer_frontend_version_key',

    versions : [],
    versionChangedReloadOnRouteChange : false,

    writeVersionToLocalStorage (version) {
        version = version || this.versions[this.versions.length - 1];
        if(!version) {
            return;
        }
        window.localStorage.setItem(this.FRONTEND_VERSION_STORAGE_KEY, version);
    },

    currentVersion () {
        return window.localStorage.getItem(this.FRONTEND_VERSION_STORAGE_KEY)
    },

    applyVersion (version) {
        //if we want to reload on next route dont allow any more versions to come through since multiple requests will
        //end up stacking and setting it back to false
        if(!version || this.versionChangedReloadOnRouteChange) {
            return;
        }

        //when we receive the very first version from the backend check it against the one stored in local storage
        //so we can determine if we need to force reload the page to bring in changes
        //This can happen where users aren't on the app during a deploy and when they come back the old app is still cached
        //and the versions they are receiving from the backend are are the same between requests
        if(this.versions.length === 0) {
            const priorVersion = this.currentVersion();
            if(!priorVersion) {
                this.writeVersionToLocalStorage(version);
            } else if(priorVersion !== version) {
                this.writeVersionToLocalStorage(version);
                window.location.reload(true);
            }
        }

        if(this.versions.length >= 2) {
            this.versions = [this.versions[1]];
        }
        this.versions.push(version);
        if(this.versions.length >= 2) {
            this.versionChangedReloadOnRouteChange = this.versions[0] !== this.versions[1];
        }
    },
};
